var E = Object.defineProperty;
var T = (t, n, e) => n in t ? E(t, n, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[n] = e;
var a = (t, n, e) => (T(t, typeof n != "symbol" ? n + "" : n, e), e);
import { isJSFunction as U, AssetType as s, AssetLevels as g, AssetLevel as u, TransformStage as C } from "@alilc/lowcode-types";
import { defineComponent as v, h as L } from "vue";
function O(t) {
  return t == null;
}
function f(t) {
  return !O(t) && typeof t == "object";
}
function m(t) {
  return typeof t == "function";
}
function N(t) {
  return f(t) && !!t.__esModule;
}
function b(t) {
  return /\.css$/.test(t);
}
function K(t) {
  return f(t) && t.nodeType === Node.ELEMENT_NODE;
}
function P(t) {
  return !!(m(t) || f(t) && ("render" in t || "setup" in t || "template" in t));
}
function k(t) {
  return f(t) && t.componentName === "Component";
}
function y(t) {
  return typeof t != "string" ? t : window[t] || B(t);
}
function B(t) {
  if (/^[a-z-]+$/.test(t))
    return v((n, { attrs: e, slots: r }) => () => L(t, e, r));
}
function F(t, n) {
  const e = n.length;
  if (e < 1 || !t)
    return t;
  let r = 0, i;
  for (; r < e; ) {
    const o = n[r];
    let l;
    try {
      i = t[o];
    } catch (c) {
      l = c, i = null;
    }
    if (r === 0 && i == null && o === "default") {
      if (l)
        return e === 1 ? t : null;
      i = t;
    } else if (i == null)
      return null;
    t = i, r++;
  }
  return i;
}
function H(t, n, e) {
  if (!e)
    return y(n);
  const r = e.exportName || e.componentName || n, i = t[e.package] || r, o = y(i), l = e.exportName && e.subName ? e.subName.split(".") : [];
  return e.destructuring ? l.unshift(r) : N(o) && l.unshift("default"), F(o, l);
}
function q(t, n, e) {
  const r = {};
  return Object.keys(n).forEach((i) => {
    let o = n[i];
    k(o) ? e && (r[i] = e(
      o
    )) : P(o) ? r[i] = o : (o = H(t, i, o), o && (r[i] = o));
  }), r;
}
function G(t, n) {
  return n.filter((e) => e && e.name).reduce((e, r) => {
    const { name: i, content: o, type: l } = r;
    if (l === "npm") {
      const { package: c, exportName: d, destructuring: p } = o != null ? o : {};
      if (t[c]) {
        const h = y(t[c]);
        h && (e[i] = p && d ? h[d] : h);
      }
    } else
      l === "function" && (e[i] = U(o) ? new Function(`return ${o.value}`)() : r.content);
    return e;
  }, {});
}
function A() {
  const t = {}, n = new Promise((e, r) => {
    t.resolve = e, t.reject = r;
  });
  return t.promise = () => n, t;
}
function J(t) {
  const n = document.createElement("script");
  n.text = t, document.head.appendChild(n), document.head.removeChild(n);
}
function R(t) {
  const n = document.createElement("script");
  n.onload = r, n.onerror = r;
  const e = A();
  function r(i) {
    n.onload = null, n.onerror = null, i.type === "load" ? e.resolve() : e.reject();
  }
  return n.src = t, n.async = !1, document.head.appendChild(n), e.promise();
}
function Q(t) {
  return new Function(t)();
}
function z(t, n) {
  try {
    return new Function(t, n);
  } catch {
    return console.warn("Caught error, Cant init func"), null;
  }
}
function V(t) {
  return t && t.type;
}
function $(t) {
  return t && t.type === s.Bundle;
}
function S(t, n, e, r) {
  return n ? { type: t, content: n, level: e, id: r } : null;
}
function _(t, n, e, r) {
  for (const i of e)
    w(t, n, i, r);
}
function w(t, n, e, r) {
  if (!e)
    return;
  if (Array.isArray(e))
    return _(t, n, e, r);
  if ($(e)) {
    if (e.assets) {
      Array.isArray(e.assets) ? _(t, n, e.assets, e.level || r) : w(t, n, e.assets, e.level || r);
      return;
    }
    return;
  }
  V(e) || (e = S(
    b(e) ? s.CSSUrl : s.JSUrl,
    e,
    r
  ));
  let i = e.level || r;
  (!i || u[i] == null) && (i = u.App), e.level = i, e.type === s.CSSUrl || e.type == s.CSSText ? n[i].push(e) : t[i].push(e);
}
class x {
  constructor(n, e) {
    a(this, "lastContent");
    a(this, "lastUrl");
    a(this, "placeholder");
    a(this, "id");
    a(this, "level");
    this.level = n, e && (this.id = e);
    let r;
    if (e && (r = document.head.querySelector(`style[data-id="${e}"]`)), !r) {
      r = document.createTextNode("");
      const i = document.head.querySelector(`meta[level="${n}"]`);
      i ? document.head.insertBefore(r, i) : document.head.appendChild(r);
    }
    this.placeholder = r;
  }
  applyText(n) {
    if (this.lastContent === n)
      return;
    this.lastContent = n, this.lastUrl = void 0;
    const e = document.createElement("style");
    e.setAttribute("type", "text/css"), this.id && e.setAttribute("data-id", this.id), e.appendChild(document.createTextNode(n)), document.head.insertBefore(
      e,
      this.placeholder.parentNode === document.head ? this.placeholder.nextSibling : null
    ), document.head.removeChild(this.placeholder), this.placeholder = e;
  }
  applyUrl(n) {
    if (this.lastUrl === n)
      return;
    this.lastContent = void 0, this.lastUrl = n;
    const e = document.createElement("link");
    e.onload = i, e.onerror = i;
    const r = A();
    function i(o) {
      e.onload = null, e.onerror = null, o.type === "load" ? r.resolve() : r.reject();
    }
    return e.href = n, e.rel = "stylesheet", this.id && e.setAttribute("data-id", this.id), document.head.insertBefore(
      e,
      this.placeholder.parentNode === document.head ? this.placeholder.nextSibling : null
    ), document.head.removeChild(this.placeholder), this.placeholder = e, r.promise();
  }
}
class W {
  constructor() {
    a(this, "stylePoints", /* @__PURE__ */ new Map());
  }
  async load(n) {
    const e = {}, r = {};
    g.forEach((l) => {
      e[l] = [], r[l] = [];
    }), w(r, e, n);
    const i = e[u.Environment].concat(
      e[u.Library],
      e[u.Theme],
      e[u.Runtime],
      e[u.App]
    ), o = r[u.Environment].concat(
      r[u.Library],
      r[u.Theme],
      r[u.Runtime],
      r[u.App]
    );
    await Promise.all(
      i.map(
        ({ content: l, level: c, type: d, id: p }) => this.loadStyle(l, c, d === s.CSSUrl, p)
      )
    ), await Promise.all(
      o.map(
        ({ content: l, type: c }) => this.loadScript(l, c === s.JSUrl)
      )
    );
  }
  loadStyle(n, e, r, i) {
    if (!n)
      return;
    let o;
    return i ? (o = this.stylePoints.get(i), o || (o = new x(e, i), this.stylePoints.set(i, o))) : o = new x(e), r ? o.applyUrl(n) : o.applyText(n);
  }
  loadScript(n, e) {
    if (!!n)
      return e ? R(n) : J(n);
  }
  async loadAsyncLibrary(n) {
    const e = [], r = [];
    for (const i in n)
      n[i].async && (e.push(window[n[i].library]), r.push(n[i].library));
    await Promise.all(e).then((i) => {
      i.length > 0 && i.map((o, l) => (window[r[l]] = o, o));
    });
  }
}
function X(t, n) {
  t.onSimulatorHostReady((e) => {
    e.set("environment", [
      S(
        s.JSText,
        "window.__is_simulator_env__=true;window.__VUE_DEVTOOLS_GLOBAL_HOOK__=window.parent.__VUE_DEVTOOLS_GLOBAL_HOOK__;"
      ),
      S(s.JSUrl, n, void 0, "vue")
    ]);
  });
}
function Y(t, n) {
  let e = null;
  return n ? function() {
    e && clearTimeout(e), e = setTimeout(() => {
      e = null, t.apply(this);
    }, n);
  } : function() {
    e || (e = setTimeout(() => {
      e = null, t.apply(this);
    }));
  };
}
function Z(t) {
  if (f(t)) {
    if (m(t.export))
      return t.export(C.Render);
    if (m(t.exportSchema))
      return t.exportSchema(C.Render);
  }
  return null;
}
export {
  W as AssetLoader,
  x as StylePoint,
  y as accessLibrary,
  S as assetItem,
  q as buildComponents,
  G as buildUtils,
  A as createDefer,
  Y as debounce,
  J as evaluate,
  Q as evaluateExpression,
  Z as exportSchema,
  H as findComponent,
  B as generateHtmlComp,
  F as getSubComponent,
  $ as isAssetBundle,
  V as isAssetItem,
  b as isCSSUrl,
  k as isComponentSchema,
  N as isESModule,
  K as isElement,
  m as isFunction,
  O as isNil,
  f as isObject,
  P as isVueComponent,
  R as load,
  z as newFunction,
  X as setupHostEnvironment
};
